const BENEFITS_ELEMENT_NAME = "upsellMobileBenefitsBreakdown";

export default BENEFITS_ELEMENT_NAME;
